import React from "react";
import Image from "./../../assets/game_image_9-300x450.jpg";
import { IoHeartOutline } from "react-icons/io5";
import { HiOutlineShoppingBag } from "react-icons/hi";
import { MdOutlineSettingsInputComponent } from "react-icons/md";
import { IoIosStar } from "react-icons/io";

const Card = () => {
  return (
    <div className="bg-white rounded-[8px] relative overflow-hidden group max-w-[270px]">
      <img src={Image} alt="" className="rounded-[8px] w-full p-2" />
      <div className="absolute top-3 right-3 bg-red-700 rounded-full w-10 h-10 font-rubik flex justify-center items-center text-white uppercase">
        Hot
      </div>
      <div className="p-2 pb-6">
        <p className="font-rubik font-bold hover:text-primary">Wreckfest</p>
        <div className="flex gap-2 my-2">
          <p className="font-rubik font-bold text-primary">89$</p>
          <del className="font-rubik font-bold text-[#b0b8bf]">49$</del>
        </div>
        <div className="flex text-[#febf00]">
            <IoIosStar />
            <IoIosStar />
            <IoIosStar />
            <IoIosStar />
            <IoIosStar />
        </div>
      </div>

      <div className="absolute w-full bottom-[-100%] bg-white gap-[1px] transition-all duration-300 group-hover:bottom-0">
        <div className="flex gap-[1px]">
          <div className="flex-1 bg-primary flex justify-center items-center p-3 text-xl text-white">
            <HiOutlineShoppingBag />
          </div>
          <div className="flex-1 bg-primary flex justify-center items-center p-3 text-xl text-white">
            <IoHeartOutline />
          </div>
          <div className="flex-1 bg-primary flex justify-center items-center p-3 text-xl text-white">
            <MdOutlineSettingsInputComponent />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
